var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 9.31875V11.5312H9.31875V9.31875H11.5312ZM12.6375 8.2125H8.2125V12.6375H12.6375V8.2125ZM11.5312 15.2188V17.4313H9.31875V15.2188H11.5312ZM12.6375 14.1125H8.2125V18.5375H12.6375V14.1125ZM17.4313 9.31875V11.5312H15.2188V9.31875H17.4313ZM18.5375 8.2125H14.1125V12.6375H18.5375V8.2125ZM14.1125 14.1125H15.2188V15.2188H14.1125V14.1125ZM15.2188 15.2188H16.325V16.325H15.2188V15.2188ZM16.325 14.1125H17.4313V15.2188H16.325V14.1125ZM14.1125 16.325H15.2188V17.4313H14.1125V16.325ZM15.2188 17.4313H16.325V18.5375H15.2188V17.4313ZM16.325 16.325H17.4313V17.4313H16.325V16.325ZM17.4313 15.2188H18.5375V16.325H17.4313V15.2188ZM17.4313 17.4313H18.5375V18.5375H17.4313V17.4313ZM20.75 9.6875H19.275V7.475H17.0625V6H20.75V9.6875ZM20.75 20.75V17.0625H19.275V19.275H17.0625V20.75H20.75ZM6 20.75H9.6875V19.275H7.475V17.0625H6V20.75ZM6 6V9.6875H7.475V7.475H9.6875V6H6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.0fb54632.svg";
export { ForwardRef as ReactComponent };